import * as angular from "angular";
import * as _ from "lodash";
import {OrganizationsRequestsService} from "./services/organizations-requests.factory";
import {GlobalsRequestsService} from "../globals/services/globals-requests.service";
import {ConfigurationCommons} from "../commons/services/configuration-commons.service";
import {SitesRequestsService} from "../sites/services/sites-requests.service";

angular
  .module('bringoz.admin.organizations')
  .config(organizationsConfig);


function organizationsConfig($stateProvider) {
  $stateProvider

    // ******************************************
    // Organizations Details - Super View
    // ******************************************

    .state('organizations', {
      parent: 'bringoz.super',
      abstract: true,
      url: '/organizations',
      template: '<organizations-details></organizations-details>'
    })

    // Overview
    .state('organizations.overview', {
      url: '/welcome?:from&:to',
      controllerAs: 'vm',
      template: '<organizations-overview resources="vm.resources"></organizations-overview>',
      controller: function ($scope, resources, triBreadcrumbsService, $stateParams) {

        if ($stateParams.from || $stateParams.to) {
          $scope.from = parseInt($stateParams.from);
          $scope.to = parseInt($stateParams.to);
        }

        this.resources = resources;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Overview"});
        triBreadcrumbsService.addCrumb({name: "Welcome Bringoz"});
      },
      resolve: {
        resources: (IamRequests) => {
          return IamRequests.getResources();
        }
      }
    })

    // Organizations
    .state('organizations.list', {
      url: '/list',
      template: '<organizations-list-view organizations="$resolve.organizations"></organizations-list-view>',
      controller: function ($scope, triBreadcrumbsService) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Organizations"});
        triBreadcrumbsService.addCrumb({name: "Welcome Bringoz"});
      },
      resolve: {
        organizations: function (organizationsRequestsService: OrganizationsRequestsService) {
          return organizationsRequestsService.getOrganizations();
        }
      }
    })

    // Addresses Resolver
    // .state('organizations.addresses-resolver', {
    //     url: '/address-validations?:quality',
    //     template: '<addresses-resolver-view quality="quality"></addresses-resolver-view>',
    //     controller: function($scope, triBreadcrumbsService, $stateParams) {
    //
    //         $scope.quality = $stateParams.quality || 'Low';
    //
    //         // Bread Crumbs
    //         triBreadcrumbsService.reset();
    //         triBreadcrumbsService.addCrumb({name: "Address Validations"});
    //         triBreadcrumbsService.addCrumb({name: "Welcome Bringoz"});
    //     }
    // })

    // Policy - Abstract
    .state('organizations.policy', {
      url: '/policy',
      abstract: true,
      template: '<policy-view></policy-view>',
      resolve: {
        extendedPolicy: function (IamRequests) {
          return IamRequests.getSuperPolicy();
        }
      }
    })

    .state('organizations.policy.users', {
      url: '/users',
      template: '<policy-users-view extended-policy="vm.extendedPolicy"></policy-users-view>',
      controllerAs: 'vm',
      controller: function ($scope, triBreadcrumbsService, extendedPolicy) {

        this.extendedPolicy = extendedPolicy;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Users'});
        triBreadcrumbsService.addCrumb({name: "Security"});
        triBreadcrumbsService.addCrumb({name: "Welcome Bringoz"});
      }
    })

    .state('organizations.policy.service-accounts', {
      url: '/service-accounts',
      template: '<policy-service-accounts-view extended-policy="vm.extendedPolicy"></policy-service-accounts-view>',
      controllerAs: 'vm',
      controller: function ($scope, triBreadcrumbsService, extendedPolicy) {

        this.extendedPolicy = extendedPolicy;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'API Keys'});
        triBreadcrumbsService.addCrumb({name: "Security"});
        triBreadcrumbsService.addCrumb({name: "Welcome Bringoz"});
      }
    })

    .state('organizations.policy.password', {
      url: '/password',
      template: '<policy-password-view extended-policy="vm.extendedPolicy"></policy-password-view>',
      controllerAs: 'vm',
      controller: function ($scope, triBreadcrumbsService, extendedPolicy) {

        this.extendedPolicy = extendedPolicy;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Password Policy'});
        triBreadcrumbsService.addCrumb({name: "Security"});
        triBreadcrumbsService.addCrumb({name: "Welcome Bringoz"});
      }
    })

    .state('organizations.policy.token', {
      url: '/token',
      template: '<policy-token-view extended-policy="vm.extendedPolicy"></policy-token-view>',
      controllerAs: 'vm',
      controller: function ($scope, triBreadcrumbsService, extendedPolicy) {

        this.extendedPolicy = extendedPolicy;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Token Policy'});
        triBreadcrumbsService.addCrumb({name: "Security"});
        triBreadcrumbsService.addCrumb({name: "Welcome Bringoz"});
      }
    })

    .state('organizations.policy.groups', {
      url: '/groups',
      template: '<roles-groups extended-policy="vm.extendedPolicy"></roles-groups>',
      controllerAs: 'vm',
      controller: function ($scope, triBreadcrumbsService, extendedPolicy) {

        this.extendedPolicy = extendedPolicy;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Groups'});
        triBreadcrumbsService.addCrumb({name: 'Settings'});
        triBreadcrumbsService.addCrumb({name: 'Administration'});

      },
      // resolve: {
      //   extendedPolicy: (sitesRequestsService: SitesRequestsService, site) => {
      //     return sitesRequestsService.getSitePolicy(site.id);
      //   }
      // }
    })

    // User - Abstract
    .state('organizations.policy.user', {
      url: '/users/:userId',
      abstract: true,
      template: '<admin-user-view tabs="tabs"></admin-user-view>',
      controller: function ($scope) {
        $scope.tabs = ['info'];
      },
      resolve: {
        user: function (extendedPolicy, $stateParams) {
          return _.find(extendedPolicy.users, function (user) {
            return user.id === $stateParams.userId
          });
        }
      }
    })

    // User Info
    .state('organizations.policy.user.info', {
      url: '/info',
      template: '<admin-user-info user="vm.user" extended-policy="vm.extendedPolicy"></admin-user-info>',
      controllerAs: 'vm',
      controller: function ($scope, user, extendedPolicy, triBreadcrumbsService) {
        this.user = user;
        this.extendedPolicy = extendedPolicy;
        this.roleOptions = extendedPolicy.roles;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: user.firstName + ' ' + user.lastName, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Users', state: 'organizations.policy.users'});
        triBreadcrumbsService.addCrumb({name: "Security"});
        triBreadcrumbsService.addCrumb({name: "Welcome Bringoz"});
      }
    })

    .state('organizations.globals', {
      url: '/globals',
      template: '<globals-view globals="globals"></globals-view>',
      controller: function ($scope, configurationCommons: ConfigurationCommons, triBreadcrumbsService, globals) {
        $scope.globals = configurationCommons.getGlobalsByGroup(globals);

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Global Preferences"});
        triBreadcrumbsService.addCrumb({name: "Welcome Bringoz"});
      },
      resolve: {
        globals: function (globalsRequestsService: GlobalsRequestsService) {
          return globalsRequestsService.getGlobals();
        }
      }
    })



    // ******************************************
    // Organization Details - Organization View
    // ******************************************

    .state('organization', {
      parent: 'bringoz.org',
      url: '/organization',
      abstract: true,
      template: '<organization-details organization="organization"></organization-details>',
      controller: function ($scope, triBreadcrumbsService, organization) {
        $scope.organization = organization;
      }
    })

    // Overview
    .state('organization.overview', {
      url: '/overview?:from&:to',
      template: '<organization-overview from="from" to="to" sites="sites"></organization-overview>',
      controller: function ($scope, triBreadcrumbsService, $stateParams, $state, sites, organization) {

        $scope.sites = sites;

        if ($stateParams.from || $stateParams.to) {
          $scope.from = parseInt($stateParams.from);
          $scope.to = parseInt($stateParams.to);
        }


        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Overview"});
        triBreadcrumbsService.addCrumb({name: organization.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: "Organizations", state: 'organizations.list'});
      },
      resolve: {
        sites: function (organizationsRequestsService: OrganizationsRequestsService, organization) {
          return organizationsRequestsService.getOrganizationSites(organization.id);
        }
      }
    })

    // Sites
    .state('organization.sites', {
      url: '/sites',
      template: '<organization-sites sites="sites" organization="organization"></organization-sites>',
      controller: function ($scope, triBreadcrumbsService, sites, organization) {

        $scope.sites = sites;
        $scope.organization = organization;


        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Sites"});
        triBreadcrumbsService.addCrumb({name: organization.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: "Organizations", state: 'organizations.list'});
      },
      resolve: {
        sites: function (orgId, organizationsRequestsService: OrganizationsRequestsService) {
          return organizationsRequestsService.getOrganizationSites(orgId);
        }
      }
    })

    // Policy - Abstract
    .state('organization.policy', {
      url: '/policy',
      abstract: true,
      template: '<policy-view></policy-view>',
      resolve: {
        extendedPolicy: function (organizationsRequestsService: OrganizationsRequestsService, organization) {
          return organizationsRequestsService.getOrganizationPolicy(organization.id);
        }
      }
    })

    .state('organization.policy.users', {
      url: '/users',
      template: '<policy-users-view extended-policy="vm.extendedPolicy" org-id="vm.orgId"></policy-users-view>',
      controllerAs: 'vm',
      controller: function ($scope, triBreadcrumbsService, extendedPolicy, organization) {

        this.extendedPolicy = extendedPolicy;
        this.orgId = organization.id;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Users'});
        triBreadcrumbsService.addCrumb({name: "Security"});
        triBreadcrumbsService.addCrumb({name: organization.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: "Organizations", state: 'organizations.list'});
      }
    })

    .state('organization.policy.service-accounts', {
      url: '/service-accounts',
      template: '<policy-service-accounts-view extended-policy="vm.extendedPolicy" org-id="vm.orgId"></policy-service-accounts-view>',
      controllerAs: 'vm',
      controller: function ($scope, triBreadcrumbsService, extendedPolicy, organization) {

        this.extendedPolicy = extendedPolicy;
        this.orgId = organization.id;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'API Keys'});
        triBreadcrumbsService.addCrumb({name: "Security"});
        triBreadcrumbsService.addCrumb({name: organization.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: "Organizations", state: 'organizations.list'});
      }
    })

    .state('organization.policy.password', {
      url: '/password',
      template: '<policy-password-view extended-policy="vm.extendedPolicy" org-id="vm.orgId"></policy-password-view>',
      controllerAs: 'vm',
      controller: function ($scope, triBreadcrumbsService, extendedPolicy, organization) {

        this.extendedPolicy = extendedPolicy;
        this.orgId = organization.id;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Password Policy'});
        triBreadcrumbsService.addCrumb({name: "Security"});
        triBreadcrumbsService.addCrumb({name: organization.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: "Organizations", state: 'organizations.list'});
      }
    })

    .state('organization.policy.token', {
      url: '/token',
      template: '<policy-token-view extended-policy="vm.extendedPolicy" org-id="vm.orgId"></policy-token-view>',
      controller: function ($scope, triBreadcrumbsService, extendedPolicy, organization) {

        this.extendedPolicy = extendedPolicy;
        this.orgId = organization.id;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Token Policy'});
        triBreadcrumbsService.addCrumb({name: "Security"});
        triBreadcrumbsService.addCrumb({name: organization.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: "Organizations", state: 'organizations.list'});
      }
    })

    .state('organization.policy.groups', {
      url: '/groups',
      template: '<roles-groups extended-policy="vm.extendedPolicy" org-id="vm.orgId"></roles-groups>',
      controllerAs: 'vm',
      controller: function ($scope, triBreadcrumbsService, extendedPolicy, organization) {

        this.extendedPolicy = extendedPolicy;
        this.orgId = organization.id;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Groups'});
        triBreadcrumbsService.addCrumb({name: 'Settings'});
        triBreadcrumbsService.addCrumb({name: 'Administration'});

      },
      // resolve: {
      //   extendedPolicy: (sitesRequestsService: SitesRequestsService, site) => {
      //     return sitesRequestsService.getSitePolicy(site.id);
      //   }
      // }
    })

    // User - Abstract
    .state('organization.policy.user', {
      url: '/users/:userId',
      abstract: true,
      template: '<admin-user-view tabs="tabs"></admin-user-view>',
      controller: function ($scope) {
        $scope.tabs = ['info']
      }
    })

    // User Info
    .state('organization.policy.user.info', {
      url: '/info',
      template: '<admin-user-info user="vm.user" extended-policy="vm.extendedPolicy" org-id="vm.orgId"></admin-user-info>',
      controllerAs: 'vm',
      controller: function ($scope, triBreadcrumbsService, extendedPolicy, user, organization) {

        this.user = user;
        this.extendedPolicy = extendedPolicy;
        this.orgId = organization.id;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: user.firstName + ' ' + user.lastName, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Users'});
        triBreadcrumbsService.addCrumb({name: "Security"});
        triBreadcrumbsService.addCrumb({name: organization.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: "Organizations", state: 'organizations.list'});
      },
      resolve: {
        user: function (extendedPolicy, $stateParams) {
          return _.find(extendedPolicy.users, function (user) {
            return user.id === $stateParams.userId
          });
        }
      }
    });
}
